module.exports = __webpack_public_path__ + "static/media/moraine-21.72204331.jpg";